import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=cbf36352&scoped=true"
import script from "./discount.vue?vue&type=script&lang=js"
export * from "./discount.vue?vue&type=script&lang=js"
import style0 from "./discount.vue?vue&type=style&index=0&id=cbf36352&prod&lang=scss&scoped=true"
import style1 from "./discount.vue?vue&type=style&index=1&id=cbf36352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf36352",
  null
  
)

export default component.exports